export const getUserGroupRoleNames = ({ client_app_roles: roles = [] } = {}) => {
  const roleNames = (Array.isArray(roles) ? roles : [])
    .map((role) => role?.name)
    .filter(Boolean);

  return roleNames.length ? roleNames.join(", ") : "-";
};
